export const setCookie = (key, value) => {
  return {
    type: "@EE/SET_COOKIE",
    key,
    value,
  };
};

export const expireCookie = (key) => {
  return {
    type: "@EE/EXPIRE_COOKIE",
    key,
  };
};
